import { supabase } from '../lib/supabase';
import type { SurveyResponse } from '../components/survey/surveyTypes';
import type { CategoryScore } from '../types/survey-student';

export interface SubmitSurveyPayload {
  responses: SurveyResponse[];
  surveyDataId?: string;
}

export interface GetResultsResponse {
  categories: CategoryScore[];
  totalResponses: number;
  completionPercentage: number;
  lastUpdated: string | null;
  hasResults: boolean;
}

export const surveyApi = {
  /**
   * Submit survey responses to the backend
   */
  async submitSurvey(payload: SubmitSurveyPayload): Promise<{ success: boolean; message: string; surveyDataId?: string; isComplete?: boolean }> {
    const { data, error } = await supabase.functions.invoke('submit-survey', {
      body: payload
    });

    if (error) {
      throw new Error(error.message || 'Failed to submit survey data');
    }

    return data;
  },

  /**
   * Submit a single survey response (for incremental saving)
   */
  async submitResponse(response: SurveyResponse, surveyDataId?: string): Promise<void> {
    const { error } = await supabase.functions.invoke('submit-survey', {
      body: {
        responses: [response],
        surveyDataId
      }
    });

    if (error) {
      throw new Error(error.message || 'Failed to submit response');
    }
  },

  /**
   * Get calculated results for a user
   * @param userId - Optional user ID. If not provided, gets results for the authenticated user
   */
  async getResults(userId?: string): Promise<GetResultsResponse> {
    const url = userId ? `get-results?user_id=${encodeURIComponent(userId)}` : 'get-results';
    
    const { data, error } = await supabase.functions.invoke(url, {
      method: 'GET'
    });

    if (error) {
      throw new Error(error.message || 'Failed to get results');
    }

    return data;
  }
};